// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { ZitadelUser } from "@src/types/user-management";

export const getUserById = async (namespace: string, userId: string) => {
  const url = userManagerUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<ZitadelUser>(
      `${url}/api/v1/ns/${namespace}/users/human/${userId}`,
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw err;
    } else {
      throw new Error("An unexpected error occurred while fetching users.");
    }
  }
};
